import { mapState } from 'vuex'
import moment from 'moment-timezone'
import 'moment-duration-format'

export default {
  computed: mapState(['plans']),
  methods: {
    sseConnect () {
      this.$sse.token = this.token
      this.$sse.role = this.roleId
      this.$sse.connect()
    },
    toCalendar (ts) {
      return moment.unix(ts).calendar()
    },
    fromNow (ts) {
      return moment.unix(ts).fromNow()
    },
    toDuration (duration) {
      return moment.duration(duration, 'seconds').format('h [min] s [sec]')
    },
    toDate  (ts) {
      return moment.unix(ts).format('DD/MM/YYYY')
    },
    toSlug (str) {
      str = str.replace(/^\s+|\s+$/g, '').toLowerCase()

      const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      const to = 'aaaaeeeeiiiioooouuuunc------'

      for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      return str.replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
    },
    regionName (planId) {
      const plan = this.plans.find((p) => p.id === planId)
      if (plan) {
        return plan.region.name
      }
    },
    regionFlag (planId) {
      const plan = this.plans.find((p) => p.id === planId)
      if (plan) {
        return '/flags/' + plan.region.country + '.png'
      }
    },
    bundleImage (bundleId) {
      bundleId = this.application ? this.application.bundleId : bundleId
      return '/bundles/' + bundleId + '.svg'
    },
    planProvider (planId) {
      const plan = this.plans.find((p) => p.id === planId)
      if (plan) {
        return plan.provider.name
      }
    },
    planProviderLogo (planId) {
      const plan = this.plans.find((p) => p.id === planId)
      if (plan) {
        return '/providers/' + plan.provider.name.replace(/\s+/g, '').toLowerCase() + '.png'
      }
    },
    planDescription (planId, light) {
      const plan = this.plans.find((p) => p.id === planId)
      if (plan) {
        return (plan.memory ? plan.memory + ' GB' : plan.memoryMb + ' MB') +
          (light ? '' : ' Memory') + ' / ' + plan.vcpus +
          (light ? '' : ' ' + plan.cpu) + ' ' + this.plural('CPU', plan.vcpus)
      }
    },
    planNetworks (planId) {
      const plan = this.plans.find((p) => p.id === planId)
      if (plan) {
        return plan.provider.networks
      }
    },
    applicationUrl (config) {
      return (config.proxy_scheme || 'https') + '://' + config.hostname
    },
    plural (text, count) {
      return text + (count > 1 ? 's' : '')
    },
    textCase (a, b, condition) {
      return condition ? a : b
    },
    capitalize (s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    storageFee (size) {
      return Math.ceil((size - 10) / 5) * 100
    },
    hasFeature (feature, features) {
      return (features || []).indexOf(feature) !== -1
    },
    accountName (client) {
      return client.id.replace('cus_', '')
    }
  }
}
